import { gql } from "apollo-boost";

export const GET_VEHICLES_FOR_BUSINESS_CUSTOMER = gql`
  query getVehiclesForBusinessCustomer($businessCustomerId: ID!,$driver:ID) {
    getVehiclesForBusinessCustomer(businessCustomerId: $businessCustomerId, driver:$driver) {
      insurerCode
      isGhostVehicle
      assetTag
      bodyType
      colour
      fuelType
      licencePlate
      vin
      make
      model
      year
      imageUrl
      numberOfDoors
      status
      id
      branch
      branchDetails {
        id
        name
      }
      telematicCoreData {
        latitude
        longitude
      }
      smartCarVehicleData {
          vehicleLocation {
            latitude
            longitude
          }
        }
      activeBookingSchedule{
        booking{
          id
          referenceNumber
          pickupDateTime
          dropoffDateTime
          branch{
            id
            timeZone
          }
          vehicleGroups {
            name
            mileageLimit
            unlimitedMileage
            pricePerExtraMile
          }
        }
        driver {
          id
          note
        }
        id
        dropoffCheck {
          vehicleState {
            id
            odometerReading
          }
        }
      }
      vehicleState {
        id
        odometerReading
        updatedAt
        createdAt
      }
      vehicleTestReports {
        testDate
        expiryDate
        testResult
        odometerReading
        odometerUnit
        motTestNumber
        advisoryItems
        minorItems
        failureItems
      }
      services {
        id
        appointmentDate
        startDate
        endDate
        completionDate
        status
      }
    }
  }
`;

export const GET_VEHICLES_FOR_INDIVIDUAL_CUSTOMER = gql`
  query getVehiclesForIndividualCustomer($customerId: ID!) {
    getVehiclesForIndividualCustomer(customerId: $customerId) {
      insurerCode
      isGhostVehicle
      assetTag
      bodyType
      colour
      fuelType
      licencePlate
      vin
      make
      model
      year
      imageUrl
      numberOfDoors
      status
      id
      branch
      branchDetails {
        id
        name
      }
      telematicCoreData {
        latitude
        longitude
      }
      smartCarVehicleData {
          vehicleLocation {
            latitude
            longitude
          }
        }
      activeBookingSchedule{
        booking{
          id
          referenceNumber
          pickupDateTime
          dropoffDateTime
          branch{
            id
            timeZone
          }
        }
        id
      }
      vehicleState {
        updatedAt
        createdAt
      }
    }
  }
`;